import { useState } from 'react';

export function StartsAtStopsAt({
  startsAt,
  stopsAt,
  setStartsAt,
  setStopsAt,
  trads,
}) {
  const [showStartsAtEditor, setShowStartsAtEditor] = useState(false);
  const [startsAtDays, setStartsAtDays] = useState('');

  const [showStopsAtEditor, setShowStopsAtEditor] = useState(false);
  const [stopsAtDays, setStopsAtDays] = useState('');

  const t = trads?.index?.startsAtStopsAt || {};

  const formatFutureDate = (daysCount) => {
    if (!daysCount || isNaN(daysCount)) return '';
    const date = new Date();
    date.setDate(date.getDate() + parseInt(daysCount, 10));
    return date.toLocaleDateString();
  };

  return (
    <div className="">
      <div>
        {!showStartsAtEditor ? (
          <button
            type="button"
            onClick={() => setShowStartsAtEditor(true)}
            data-testid="starts-at-toggle"
            className="text-sm font-medium text-gray-900 underline hover:text-gray-700"
          >
            {startsAt
              ? (
                  t.activeBeginning || 'Active beginning {date} (Click to edit)'
                ).replace('{date}', new Date(startsAt).toLocaleDateString())
              : t.activateEventOnly || 'Activate event only at a specific date'}
          </button>
        ) : (
          <div className="flex items-center gap-2 text-sm">
            <span>{t.in || 'In'}</span>
            <input
              type="number"
              min="1"
              step="1"
              placeholder="20"
              value={startsAtDays}
              onChange={(e) =>
                setStartsAtDays(e.target.value.replace(/\D/g, ''))
              }
              data-testid="starts-at-days-input"
              className="w-20 px-2 py-1 border border-gray-300 rounded-md"
            />
            <span>{t.days || 'days'}</span>
            <span className="text-gray-500 font-medium w-24">
              {formatFutureDate(startsAtDays)}
            </span>
            <button
              type="button"
              onClick={() => {
                setShowStartsAtEditor(false);
                setStartsAtDays('');
              }}
              className="px-2 py-1 text-gray-600 bg-gray-100 rounded hover:bg-gray-200"
            >
              {t.cancel || 'Cancel'}
            </button>
            <button
              type="button"
              onClick={() => {
                if (startsAtDays && !isNaN(startsAtDays)) {
                  const d = new Date();
                  d.setDate(d.getDate() + parseInt(startsAtDays, 10));
                  d.setHours(0, 0, 0, 0);
                  setStartsAt(d.toISOString());
                } else {
                  setStartsAt(null);
                }
                setShowStartsAtEditor(false);
              }}
              data-testid="starts-at-save-btn"
              className="px-2 py-1 text-white bg-indigo-600 rounded hover:bg-indigo-700"
            >
              {t.save || 'Save'}
            </button>
          </div>
        )}
      </div>

      <div className="mt-2">
        {!showStopsAtEditor ? (
          <button
            type="button"
            onClick={() => setShowStopsAtEditor(true)}
            data-testid="stops-at-toggle"
            className="text-sm font-medium text-gray-900 underline hover:text-gray-700"
          >
            {stopsAt
              ? (t.deactivates || 'Deactivates {date} (Click to edit)').replace(
                  '{date}',
                  new Date(stopsAt).toLocaleDateString()
                )
              : t.deactivateEventAt || 'Deactivate event at a specific date'}
          </button>
        ) : (
          <div className="flex items-center gap-2 text-sm">
            <span>{t.in || 'In'}</span>
            <input
              type="number"
              min="1"
              step="1"
              placeholder="40"
              value={stopsAtDays}
              onChange={(e) =>
                setStopsAtDays(e.target.value.replace(/\D/g, ''))
              }
              data-testid="stops-at-days-input"
              className="w-20 px-2 py-1 border border-gray-300 rounded-md"
            />
            <span>{t.days || 'days'}</span>
            <span className="text-gray-500 font-medium w-24">
              {formatFutureDate(stopsAtDays)}
            </span>
            <button
              type="button"
              onClick={() => {
                setShowStopsAtEditor(false);
                setStopsAtDays('');
              }}
              className="px-2 py-1 text-gray-600 bg-gray-100 rounded hover:bg-gray-200"
            >
              {t.cancel || 'Cancel'}
            </button>
            <button
              type="button"
              onClick={() => {
                if (stopsAtDays && !isNaN(stopsAtDays)) {
                  const d = new Date();
                  d.setDate(d.getDate() + parseInt(stopsAtDays, 10));
                  d.setHours(23, 59, 59, 999);
                  setStopsAt(d.toISOString());
                } else {
                  setStopsAt(null);
                }
                setShowStopsAtEditor(false);
              }}
              data-testid="stops-at-save-btn"
              className="px-2 py-1 text-white bg-indigo-600 rounded hover:bg-indigo-700"
            >
              {t.save || 'Save'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
